import { Badge, Bank, CardList, Flex, Grid, Space, Typography } from "@payping/web-components";
import { CuToman, PhRIdentificationCard, PhRPhone } from "@payping/icons";
import { DisplayModeEnum, ListCardProps } from "@payping/web-components/components/List/types";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { useAppSelector } from "@/utils";
import { formatLocalizedNumber } from "@payping/utilities-shared/number";

const ShowList = () => {
  const { t } = useAppTranslation();
  const { createdRequest } = useAppSelector((state) => state.cashOuts);
  const { md } = Grid.useBreakpoint();

  const data: ListCardProps["dataSource"] = createdRequest?.settlements?.map((settlement) => ({
    actions: [
      <Flex align="center">
        <Typography.Text key={1}>{`${formatLocalizedNumber({ value: settlement?.amount ?? 0 })}`}</Typography.Text>
        <CuToman width={24} height={24} />
      </Flex>,
    ],
    descriptions: (
      <Flex vertical={!md} gap={16}>
        {settlement?.iban ? (
          <Space>
            <Typography.Text type={"secondary"}>{settlement.iban}</Typography.Text>
            <Bank.Icon showTooltip iban={settlement.iban} />
          </Space>
        ) : null}

        {settlement?.mobile ? (
          <Space>
            <Typography.Text type={"secondary"}>{settlement.mobile}</Typography.Text>
            <PhRPhone width={20} className="color--gray700" />
          </Space>
        ) : null}

        {settlement?.nationalId ? (
          <Space>
            <Typography.Text type={"secondary"}>{settlement.nationalId}</Typography.Text>
            <PhRIdentificationCard width={20} className="color--gray700" />
          </Space>
        ) : null}
      </Flex>
    ),
    title: {
      primary:
        settlement.fullName === " " ? (
          <Flex gap={"small"}>
            <Badge status={"error"} />
            <Typography.Title level={5}>{t("settlement.create.unclearInquiry")}</Typography.Title>
          </Flex>
        ) : (
          settlement.fullName
        ),
    },
    key: settlement.code || "",
  }));

  return (
    <CardList
      grid={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1, column: 0 }}
      dataSource={data}
      mode={md ? DisplayModeEnum.List : DisplayModeEnum.Card}
    />
  );
};

export default ShowList;
